import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState, useEffect, createContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import dataDogUtils from './dataDogUtils';
import { jsx as _jsx } from "react/jsx-runtime";
var DataDogContext = /*#__PURE__*/createContext({});
var getDefaultRumConfig = function getDefaultRumConfig() {
  return {
    applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: process.env.REACT_APP_DD_SITE,
    env: process.env.REACT_APP_ENV,
    service: process.env.REACT_APP_SERVICE_NAME,
    sampleRate: 100,
    premiumSampleRate: 0,
    // cost 4 times more, to turn on please discuss with mechanix team
    trackInteractions: true,
    allowedTracingOrigins: [/https:\/\/.*\.spdigital\.sg/, process.env.REACT_APP_API_BASE || '', process.env.REACT_APP_API_BASE_EXT || '', process.env.REACT_APP_AUTH0_BASE || ''],
    defaultPrivacyLevel: 'mask-user-input',
    excludedActivityUrls: [
    // exclude url includes sensitive token in url params
    /[?&]token=/],
    silentMultipleInit: true
  };
};
var getDefaultLogsConfig = function getDefaultLogsConfig() {
  return {
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: process.env.REACT_APP_DD_SITE,
    env: process.env.REACT_APP_ENV,
    service: process.env.REACT_APP_SERVICE_NAME,
    beforeSend: function beforeSend(log) {
      // remove sensitive info from view url
      log.view.url = dataDogUtils.replaceSensitive(log.view.url);
    },
    forwardErrorsToLogs: true,
    silentMultipleInit: true,
    sampleRate: 100
  };
};
var DataDogProvider = function DataDogProvider(_ref) {
  var children = _ref.children,
    rum = _ref.rum,
    rumConfig = _ref.rumConfig,
    logs = _ref.logs,
    logsConfig = _ref.logsConfig;
  var _useState = useState(datadogRum),
    dataDogRumState = _useState[0],
    setDataDogRumState = _useState[1];
  var _useState2 = useState(datadogLogs),
    datadogLogsState = _useState2[0],
    setDataDogLogsState = _useState2[1];
  var defaultRumConfig = getDefaultRumConfig();
  var defaultLogsConfig = getDefaultLogsConfig();
  var validate = function validate(config, type) {
    var requiredKeys = ['applicationId', 'clientToken', 'site', 'env', 'service'];
    if (type === 'LOGS') {
      requiredKeys.splice(requiredKeys.indexOf('applicationId'), 1);
    }
    requiredKeys.map(function (key) {
      if (!config || !config[key]) {
        throw new Error("Missing DataDog config for \"".concat(key, "\""));
      }
      return null;
    });
    return true;
  };
  var combinedRumConfig = _extends({}, defaultRumConfig, rumConfig);
  var combinedLogsConfig = _extends({}, defaultLogsConfig, logsConfig);
  useEffect(function () {
    if (!rum && !logs) {
      console.error('Datadog failed to start!');
    }
    if (rum && validate(combinedRumConfig, 'RUM')) {
      datadogRum.init(combinedRumConfig);
      setDataDogRumState(datadogRum);
    }
    if (logs && validate(combinedLogsConfig, 'LOGS')) {
      console.warn('The DD Logs is still in testing mode.' + 'We are not responsible for any breakage due to major change to the interface');
      datadogLogs.init(combinedLogsConfig);
      setDataDogLogsState(datadogLogs);
    }
  }, [rum, logs]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(DataDogContext.Provider, {
    value: {
      datadogRum: dataDogRumState,
      datadogLogs: datadogLogsState
    },
    children: children
  });
};
export { DataDogContext, DataDogProvider };